import { X } from "@phosphor-icons/react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { iconForEvent } from "@/lib/event-icons";

// Pin-style event icon overlaid on a row at a computed x-coord. Shows a tooltip
// with comment/date/author on hover; edit-mode shows a delete button.
export default function GanttEventIcon({ event, x, canEdit, onDelete }) {
  const meta = iconForEvent(event);
  const Icon = meta.icon;
  const color = event.color || meta.color;
  const label = event.icon_label || meta.label;
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            data-event-anchor="event"
            onClick={(e) => e.stopPropagation()}
            className="absolute z-[25] cursor-pointer"
            style={{ left: x, top: 4, transform: "translateX(-50%)" }}
            data-testid={`event-${event.id}`}
          >
            <div
              className="w-[22px] h-[22px] rounded-md border-2 border-white shadow-sm flex items-center justify-center"
              style={{ background: color }}
            >
              <Icon size={12} weight="fill" className="text-white" />
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent className="rounded-md max-w-xs">
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="text-[10px] font-mono-ibm uppercase tracking-widest opacity-70">
                {label}
              </div>
              {event.comment && (
                <div className="text-xs mt-1 leading-relaxed">{event.comment}</div>
              )}
              {event.event_date && (
                <div className="text-[10px] text-slate-300 mt-1 font-mono-ibm">
                  {event.event_date}
                </div>
              )}
              {event.author_email && (
                <div className="text-[10px] text-slate-400 mt-1 font-mono-ibm">— {event.author_email}</div>
              )}
            </div>
            {canEdit && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); onDelete(); }}
                className="text-slate-400 hover:text-red-400"
                data-testid={`delete-event-${event.id}`}
              >
                <X size={12} weight="bold" />
              </button>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
